import React from 'react';
import { Text, Flex, VStack, Spinner, Box } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
const TypeaheadDropDown = ({ isHidden, results, showLoadingSpinner, showNoResultsMessage, onClick, }) => {
    const tokens = useTokens();
    const baseOptionStyle = {
        w: 'full',
        py: tokens.Spacing04,
        px: tokens.Spacing05,
        alignItems: 'center',
        height: '44px',
    };
    const styles = {
        dropDown: {
            overflowY: 'auto',
            position: 'absolute',
            top: '70px',
            maxH: '250px',
            zIndex: 1000,
            background: 'white',
            borderRadius: tokens.BorderRadius02,
            boxShadow: '0px 2px 4px 0px rgba(26, 26, 26, 0.40);',
            w: 'full',
        },
        option: {
            ...baseOptionStyle,
            _hover: {
                backgroundColor: tokens.SecondaryNavigationHover,
            },
            cursor: 'pointer',
        },
        noResults: baseOptionStyle,
    };
    return (React.createElement(VStack, { sx: styles.dropDown, spacing: 0, hidden: isHidden, "data-testid": "typeahead_results_container" },
        React.createElement(RenderIf, { condition: showLoadingSpinner },
            React.createElement(Box, { w: "100%" },
                React.createElement(Flex, { sx: styles.option, "data-testid": "typeahead_fetching_spinner" },
                    React.createElement(Spinner, { size: "sm" })))),
        React.createElement(RenderIf, { condition: showNoResultsMessage },
            React.createElement(Box, { w: "100%" },
                React.createElement(Flex, { sx: styles.noResults, "data-testid": "typeahead_no_results" },
                    React.createElement(Text, { variant: "dk-800-rg-4", mb: 0 }, localise('NO_RESULTS_FOUND'))))),
        React.createElement(RenderIf, { condition: !showNoResultsMessage },
            React.createElement(Box, { "data-testid": "typeahead_results_list", w: "100%" }, results?.map((result) => (React.createElement(Flex, { sx: styles.option, key: result.id, onClick: () => onClick(result) },
                React.createElement(Text, { variant: "dk-800-rg-4", mb: 0 }, result.full_name))))))));
};
export default TypeaheadDropDown;
